import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class AmountsUtilsService {

  getFormatNumbers(amount: string) {
    if (!amount || amount === "") {
      return "0.00"
    }
    return parseFloat(amount).toLocaleString("es-MX", {minimumFractionDigits: 2, maximumFractionDigits: 2})
  }
}
